import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import {
    FaBoxOpen,
    FaChartPie,
    FaClipboardList,
    FaSignOutAlt,
    FaStore,
    FaUsers,
} from 'react-icons/fa';

const navItems = [
    { labelKey: 'dashboard.common.dashboard', to: '/dashboard', icon: FaChartPie, end: true },
    { labelKey: 'dashboard.common.inventory', to: '/dashboard/products', icon: FaBoxOpen },
    { labelKey: 'dashboard.common.sales', to: '/dashboard/orders', icon: FaClipboardList },
    { labelKey: 'dashboard.common.customers', to: '/dashboard/customers', icon: FaUsers },
    { labelKey: 'dashboard.common.logout', to: '/login', icon: FaSignOutAlt },
];

const Sidebar = () => {
    const { t } = useTranslation();
    return (
        <section className="col-span-1 lg:col-span-2 md:col-span-3 hidden md:block">
            <aside className="sticky top-[70px] overflow-hidden rounded-lg border border-slate-200 bg-white shadow-sm">
                <div className="border-b border-slate-100 bg-[#00595A] px-5 py-5 text-left">
                    <div className="flex items-center gap-3">
                        <span className="grid h-11 w-11 place-items-center rounded bg-white/15 text-white">
                            <FaStore />
                        </span>
                        <div>
                            <p className="text-xs font-semibold uppercase tracking-[0.18em] text-white/70">
                                {t('dashboard.sidebar.brand')}
                            </p>
                            <h2 className="mt-1 text-lg font-semibold text-white">
                                {t('dashboard.sidebar.title')}
                            </h2>
                        </div>
                    </div>
                </div>
                <nav>
                    <ul className="space-y-1">
                        {navItems.map(({ labelKey, to, icon: Icon, end }) => (
                            <li key={labelKey}>
                                <NavLink
                                    to={to}
                                    end={end}
                                    onClick={() => {
                                        if (to === '/login') {
                                            localStorage.removeItem('stocknow_api_token');
                                        }
                                    }}
                                    className={({ isActive }) =>
                                        [
                                            'flex items-center gap-3 rounded-md px-3 py-3 text-sm font-semibold transition',
                                            isActive
                                                ? 'bg-[#00595A] text-white shadow-sm'
                                                : 'text-slate-600 hover:bg-slate-100 hover:text-[#00595A]',
                                        ].join(' ')
                                    }
                                >
                                    <Icon className="h-4 w-4 shrink-0" />
                                    <span>{t(labelKey)}</span>
                                </NavLink>
                            </li>
                        ))}
                    </ul>
                </nav>
            </aside>
        </section>
    )
}

export default Sidebar;
